
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form
} from "reactstrap";
import AdminService from "../../../../services/adminService";
import AdminForm from "../../admin/Form";

class TenantAdminCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorData: {}
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { tenantUID } = this.props.match.params;
    this.setState({ tenantUID: tenantUID });
    AdminService.create(this.state).then(response => {
      if (response.responseStatus === "SUCCESS") {
        this.props.history.push(`/superAdmin/tenant/show/${tenantUID}`);
      } else {
        this.setState({ errorData: response.data });
        console.error("Error    ==>     " + response.message);
      }
    });
  }

  render() {
    return (
      <>
        <SimpleHeader
          name="Create Admin"
          parentName="Super Admin"
          heading="ClashMate"
        />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            <CardHeader>
              <h3 className="mb-0">Create Admin</h3>
            </CardHeader>
            <CardBody>
              <Form role="form" onSubmit={this.handleSubmit}>
                <AdminForm
                  onChange={this.handleChange}
                  valueObj={this.state}
                  errorObj={this.state.errorData}
                  isEdit={false}
                  isSuperAdminView={true}
                />
                <div className="text-center">
                  <Button className="my-4" color="info" type="submit">
                    Submit
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}

export default TenantAdminCreate;
